// test100
(100 && 0);
